import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import $script from 'scriptjs';

import Forms from '../Forms';
import layout from '../Layout';
import StickyHeader from '../components/StickyHeader';
import NavMobile from '../components/NavMobile';
import NavDesktop from '../components/NavDesktop';
import HeaderSearch from '../components/HeaderSearch';
import SearchForm from '../components/SearchForm';

export default class StaticSectionHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data.settings;
    this.currency = section.data.currency;
    this.postMessage = section.postMessage;
    this.headerSearch = null;

    this.$scripts = $('[data-scripts]');

    this.$menuToggle = this.$el.find('[data-menu-toggle]');
    this.$cartCount = this.$el.find('[data-header-cart-count]');
    this.$searchField = this.$el.find('[data-live-search]');

    this.$siteNavigation = this.$el.find('[data-site-navigation]');
    this.$desktopNavigation = this.$siteNavigation.find('ul.navmenu-depth-1');
    this.$headerTools = this.$siteNavigation.find('[data-header-actions]');

    this.converter = '[data-currency-converter]';
    this.$converter = $(this.converter);

    this.stickyHeader = new StickyHeader({
      $el: this.$el,
      $toggle: this.$menuToggle,
      postMessage: this.postMessage,
    }, this.settings);

    this.navMobile = new NavMobile({
      $el: this.$el,
      $toggleOpen: this.$menuToggle,
    });

    this.navDesktop = new NavDesktop({
      $el: this.$siteNavigation,
      postMessage: this.postMessage,
    });

    this.forms = new Forms(this.$el);

    if (this.settings.live_search.enable) {
      $script(this.$scripts.data('shopify-api-url'), () => {
        this.headerSearch = new HeaderSearch({
          $el: this.$searchField,
          $header: this.$el,
        }, this.settings.live_search);
      });
    } else {
      this.headerSearch = new SearchForm(this.$searchField);
    }

    if (this.currency.enable) {
      $script(this.$scripts.data('shopify-currencies'), () => {
        this._converter();
      });
    }

    // Handle Accordion interaction when window size changes
    this._headerToolsSize = this._headerToolsSize.bind(this);
    layout.onBreakpointChange(this._headerToolsSize);

    this.$el.on('cartcount:update', (event, data) => {
      this.$cartCount
        .attr('data-header-cart-count', data.response.item_count)
        .toggleClass('visible', data.response.item_count > 0);
    });

    this._headerToolsSize();
  }
  onSectionDeselect() {
    this.navDesktop.closeAll(null);
    this.stickyHeader.closeNavigation();
  }

  onSectionUnload() {
    this.stickyHeader.unload();
    this.navMobile.unload();
    this.navDesktop.unload();
    this.forms.unload();

    this.$el.off('cartcount:update');

    this.headerSearch.unload();

    if (this.currency.enable) {
      this.$converter.off('change.converter');
    }
  }

  onSectionMessage(name, data) {
    if (name === 'nav:close-all' && layout.isBreakpoint('L')) {
      this.navDesktop.closeAll(null);
    }

    if (name === 'stickyheader:open' && this.settings.sticky_header) {
      this.stickyHeader.openNavigation(true);
    }
  }

  _converter() {
    CurrencyConverter.init({
      switcherSelector: this.converter,
      priceSelector: '.money',
      shopCurrency: this.currency.shop_currency,
      defaultCurrency: this.currency.default_currency,
      displayFormat: this.currency.display_format,
      moneyFormat: this.currency.money_format,
      moneyFormatNoCurrency: this.currency.money_format_no_currency,
      moneyFormatCurrency: this.currency.money_format_currency,
    });

    this.$converter.on('change.converter', event => {
      this.$converter.each((index, converter) => {
        if (converter.value !== event.currentTarget.value) {
          converter.value = event.currentTarget.value;
        }
      });

      CurrencyConverter.setCurrency(event.currentTarget.value);
    });
  }

  _headerToolsSize() {
    if (!layout.isBreakpoint('L')) {
      return;
    }

    const outerWidth = this.$headerTools.width();
    const innerWidths = [];

    this.$headerTools.find('li').each((index, el) => {
      innerWidths.push(Math.ceil($(el).outerWidth()));
    });

    const combinedWidths = innerWidths.reduce((a, b) => a + b, 0);

    if (combinedWidths > outerWidth) {
      this.$headerTools.css('max-width', `${combinedWidths}px`);
      this.$desktopNavigation.css('max-width', `calc(100% - ${combinedWidths}px)`);
    }
  }
}
